import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const WhatsAppChatbot = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  // Configure your WhatsApp details here
  const whatsappConfig = {
    phoneNumber: "+254797435680", // Replace with your WhatsApp business number (with country code, no + sign)
    defaultMessage: "Hello! I'm interested in your services. Can you help me?",
    businessName: "Infotrace Analytics",
  };

  const openWhatsApp = () => {
    const message = encodeURIComponent(whatsappConfig.defaultMessage);
    const whatsappUrl = `https://wa.me/${whatsappConfig.phoneNumber}?text=${message}`;
    window.open(whatsappUrl, "_blank");
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const closeChat = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="whatsapp-chatbot">
      {/* Floating WhatsApp Button */}
      <div className={`whatsapp-float ${isExpanded ? "expanded" : ""}`}>
        {isExpanded && (
          <div className="whatsapp-chat-box">
            <div className="wa-chat-header">
              <div className="wa-chat-header-content">
                <div className="wa-avatar">
                  <FontAwesomeIcon icon={faWhatsapp} />
                </div>
                <div className="wa-chat-info">
                  <h4>{whatsappConfig.businessName}</h4>
                  <span>Typically replies instantly</span>
                </div>
                <button className="wa-close-btn" onClick={closeChat}>
                  <i className="fa fa-times"></i>
                </button>
              </div>
            </div>
            <div className="wa-chat-body">
              <div className="wa-message">
                <p>Hi there! 👋</p>
                <p>How can we help you today?</p>
              </div>
            </div>
            <div className="wa-chat-footer">
              <button className="wa-start-chat-btn" onClick={openWhatsApp}>
                <FontAwesomeIcon icon={faWhatsapp} />
                Start Chat
              </button>
            </div>
          </div>
        )}

        <button
          className="whatsapp-btn"
          onClick={isExpanded ? openWhatsApp : toggleExpanded}
          title="Chat with us on WhatsApp"
        >
          <FontAwesomeIcon icon={faWhatsapp} />
        </button>
      </div>
    </div>
  );
};

export default WhatsAppChatbot;
